
import data from "./data"
import Scrollspy from "react-scrollspy"
import Nav from "./Nav"
import "./floating.css"


const FloatingNav = () => {



    return (
        <div>
            <ul id="floating__nav">
                <Scrollspy offset={-500} className="scrollspy" items={['header', 'about', 'services', 'portfolio', 'contact']} currentClassName="active">
                    {
                        data.map(item => <Nav key={item.id} item={item} />)
                    }
                </Scrollspy>
            </ul>
        </div>


    )
}

export default FloatingNav